import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

export const InspectPermissionsDialog: LoadableType<{
	contentId: string;
	onClose?: () => void;
}> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-InspectPermissionsDialog" */ '../src/InspectPermissionsDialog.tsx'
			)
		).InspectPermissionsDialog,
});
